import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Routes from "./app/router";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedIn, setToken } from "./app/store/slice/auth";

function App() {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("userProfile"));

  useEffect(() => {
    if (user?.token) {
      dispatch(setToken(user.token));
    }
    if (localStorage.getItem("isLoggedIn")) {
      dispatch(setLoggedIn(JSON.parse(localStorage.getItem("isLoggedIn"))));
    }
  }, [dispatch]);

  const { isLoggedIn } = useSelector((state) => state.auth);

  const isLoggedin = isLoggedIn || user?.token;
  return (
    <div className="App">
      <BrowserRouter basename={process.env.REACT_APP_HOME_PAGE_URL}>
        <Routes isLoggedIn={isLoggedin} />
      </BrowserRouter>
    </div>
  );
}

export default App;
